

































































































































































































































































































































import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";
import ExportButton from "@/components/ExportButton/index.vue";
import ImportExcel from "@/components/ImportExcel/index.vue";
import {
  ActivityDto,
  ActivityApplyDto,
  ActivityApplyFormSchemaDto,
  ActivitySignUpFormSchemaDto,
  AuditFlowScope,
} from "@/api/appService";
import PagedTableView from "@/components/PagedTableView/index.vue";
import EditApply from "../apply/edit.vue";
import PagedTabsTableViewForActivityApply from "@/components/PagedTableView/PagedTabsTableViewForActivityApply.vue";
import ManualCheckIn from "@/views/activity/activity/manualCheckIn.vue";

import { AuditBodyDto } from "@/utils/customDto";
import AuditBlock, { AuditApi } from "@/components/Audit/AuditBlock.vue";

@Component({
  name: "ActivityApplyList",
  components: {
    AuditBlock,
    PagedTabsTableViewForActivityApply,
    PagedTableView,
    ExportButton,
    EditApply,
    ImportExcel,
    ManualCheckIn,
  },
})
export default class ActivityApplyList extends Vue {
  @Ref() editForm!: EditApply;
  @Ref() manualCheckIn!: ManualCheckIn;

  created() {
    debugger;
    this.queryForm.activityId = this.currentActivityId;
    api.enumService
      .getValues({ typeName: "ActivityApplyStatus" })
      .then((res: any) => {
        this.applyStatusList = res;
      });
    this.reload();
  }

  reload() {
    api.activity.get({ id: Number(this.$route.params.id) }).then((res) => {
      this.detail = res;
    });
  }

  applyStatusList: any[] = [];

  queryForm = {
    applyUserName: "",
    applyUserPhone: "",
    activityTitle: "",
    status: "",
    activityId: 0,
  };

  detail: ActivityDto = {};
  activityApplyDetail: ActivityApplyDto = {};
  id = 0;
  showDetail = false;

  get currentActivityId() {
    const routeId = Number(this.$route.params.id);
    if (!Number.isNaN(routeId) && routeId > 0) {
      return routeId;
    }

    const detailId = Number(this.detail?.id);
    if (!Number.isNaN(detailId) && detailId > 0) {
      return detailId;
    }

    const formId = Number(this.queryForm.activityId);
    if (!Number.isNaN(formId) && formId > 0) {
      return formId;
    }

    return 0;
  }

  get downloadTemplateUrl() {
    return `${this.baseURL}/api/services/app/ActivityApply/DownloadTemplate?tenantId=${this.$store.getters["app/tenantId"]}&activityId=${this.currentActivityId}`;
  }

  get dynamicSignUpFields() {
    const rawFields = this.detail.signUpFormSchemas?.length
      ? this.detail.signUpFormSchemas
      : this.parseSignUpFormSchemas(this.detail.signUpFormSchemaJson);

    const duplicatedFieldNames = new Set(["Name", "PhoneNumber"]);
    const duplicatedLabels = new Set(["姓名", "手机", "手机号"]);

    return rawFields.filter((field) => {
      const fieldName = field.filedName || "";
      const label = field.name || "";
      return (
        label &&
        !duplicatedFieldNames.has(fieldName) &&
        !duplicatedLabels.has(label)
      );
    });
  }

  // 获取表数据
  fetchData(params: any) {
    debugger;
    this.queryForm.activityId = this.currentActivityId;
    return api.activityApply.getApplies({
      ...params,
      activityId: this.currentActivityId,
    });
  }

  getApplyName(row: ActivityApplyDto) {
    return row.applyUser?.surname || row.applyUser?.name || row.surname || "";
  }

  getApplyPhone(row: ActivityApplyDto) {
    return row.phoneNumber || row.applyUser?.phoneNumber || "";
  }

  getDynamicFieldValue(row: ActivityApplyDto, fieldName?: string) {
    if (!fieldName) {
      return "";
    }

    return (
      row.signUpFormSchemas?.find(
        (item: ActivityApplyFormSchemaDto) => item.name === fieldName
      )?.value || ""
    );
  }

  parseSignUpFormSchemas(raw?: string) {
    if (!raw) {
      return [] as ActivitySignUpFormSchemaDto[];
    }

    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [] as ActivitySignUpFormSchemaDto[];
    }
  }

  get auditApi() {
    return {
      canAudit: api.activityApply.canAudit,
      userAudit: api.activityApply.audit,
    } as AuditApi;
  }

  changeAudit() {
    this.fetchData(this.queryForm);
  }

  // 签到
  handleCheckIn(index: number, row: ActivityApplyDto) {
    // this.$confirm("你确定手动签到吗?", "提示").then(async () => {
    //   api.activityApply
    //     .checkIn({
    //       body: {
    //         id: row!.id,
    //       },
    //     })
    //     .then(() => {
    //       this.$message({
    //         type: "success",
    //         message: "签到成功",
    //       });
    //       this.fetchData(this.queryForm);
    //       this.reload();
    //     });
    // });

    const mc = this.manualCheckIn as any;
    mc.form.id = row.id!;
    mc.show = true;
  }

  //提交审核
  handleAudit(index: number, row: ActivityApplyDto) {
    api.activityApply.postToAudit({ body: { id: row.id } }).then(() => {
      this.fetchData(this.queryForm);
    });
  }

  // 删除
  async handleDelete(index: number, row: ActivityApplyDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.activity
        .delete({
          id: row.id,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    });
  }

  handleCreate() {
    this.queryForm.activityId = this.currentActivityId;
    if (!this.currentActivityId) {
      this.$message.error("未获取到活动Id，请刷新页面后重试");
      return;
    }
    this.editForm.show = true;
  }

  handelOnSaved() {
    this.fetchData(this.queryForm);
  }

  async jumpDetail(item: any) {
    this.$router.push({
      name: "ActivityCheckInDetail",
      params: { id: item.id!.toString() },
    });
  }

  cancel() {
    this.$router.go(-1);
  }

  hasDisplayPermission(permissionCode: string) {
    return this.hasPermission(permissionCode);
  }

  // 查看审核记录
  handleAuditFlow(row: any) {
    this.$router.push({
      name: "auditFlowDetail",
      params: {
        hostType: AuditFlowScope.ActivityApply,
        hostId: row.id,
        auditFlowId: row.auditFlowId,
      },
    });
  }
}
